import { z } from 'zod/v4';

import { routingProfileSchema } from './routing-profile.schema';

export const defaultRoutingProfileSchema = routingProfileSchema.omit({
  isAccountDefault: true,
});

export type DefaultRoutingProfile = z.infer<typeof defaultRoutingProfileSchema>;
